// extracted by mini-css-extract-plugin
export default {"managePage":"ManagePage_managePage__HglAmijP","filtersSelect":"ManagePage_filtersSelect__yU3UQNKE","sortVisibility":"ManagePage_sortVisibility__LU1PsoMJ"};